<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.gestor"
        ref="DataTable"
        sort-by="nome"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({name: 'administracao-gestor-edit', params: {id: item.id}})"
                authorize="update-administracao-gestor"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                authorize="destroy-administracao-gestor"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {repository, error} from '@/mixins'

export default {
    created() {
        this.repositories = {
            gestor: this.getConectaSusRepository('administracao.gestor')
        }
    },
    data: () => ({
        fields: [
            {key: 'nome', label: 'Nome', name: 'cadastroCidadao.nome', searchable: true, sortable: true},
            {class: 'col-min', key: 'actions', label: 'Ações', name: 'actions'},
        ],
    }),
    methods: {
        handleDestroy({id}) {
            const destroy = () => this.repositories.gestor.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o gestor?', destroy, this.handleError)
        },
    },
    mixins: [repository, error],
}
</script>